import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TokenRefreshService } from './core/services/token-refresh.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'SWF';

  constructor(tokenRefreshService: TokenRefreshService) {
    // Renews the access token 1 minute before it expires (every ~14 min), for the whole app.
    tokenRefreshService.start();
  }
}
